import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { DspAdvertiserAudienceConfig, DspProductAudienceType } from "@front/m19-api-client";
import { ITooltipDirective } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { DspAudienceLookbackConfigComponent } from "@m19-board/dsp/dsp-create-audience-page/dsp-audience-lookback-config/dsp-audience-lookback-config.component";
import { FormPreviewSplitComponent } from "@m19-board/shared/form-preview-split/form-preview-split.component";

export interface DspCreateAudienceRulesModel {
  audienceConfigs: Record<DspProductAudienceType, number[]>;
}

export interface DspCreateAudienceRulesPreview {
  baseName: string;
  audiences: DspAdvertiserAudienceConfig[];
}

@Component({
  selector: "app-dsp-create-audience-rules-step",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: "block h-full min-h-0" },
  imports: [TranslocoDirective, DspAudienceLookbackConfigComponent, FormPreviewSplitComponent, ITooltipDirective],
  templateUrl: "./dsp-create-audience-rules-step.component.html",
})
export class DspCreateAudienceRulesStepComponent {
  readonly rules = input.required<FieldTree<DspCreateAudienceRulesModel>>();
  readonly preview = input.required<DspCreateAudienceRulesPreview>();

  readonly availableAudienceTypes: DspProductAudienceType[] = [
    DspProductAudienceType.VIEWS,
    DspProductAudienceType.PURCHASES,
    DspProductAudienceType.SEARCH,
    DspProductAudienceType.SIMS,
  ];

  changeLookback(audienceType: DspProductAudienceType, lookbacks: number[]) {
    this.rules().audienceConfigs().markAsDirty();
    this.rules()
      .audienceConfigs()
      .value.update((configs) => ({
        ...configs,
        [audienceType]: lookbacks,
      }));
  }
}
